<header class="d-flex justify-content-center border-bottom">
  <img
    alt="The Walt Disney MyID Logo"
    class="mx-auto mb-4 mt-5"
    height="50"
    i18n-alt="@@header.logo.alt"
    ngSrc="MyID_logo.svg"
    priority="true"
    width="117"
  />
</header>
